/**
 * Integer Field Default Configuration
 *
 * Numeric input field for whole numbers.
 * Properties aligned with API JSON configuration structure.
 */

export interface IntegerFieldConfig {
  label: string;
  showTitle: boolean;
  exclusionType: 'hide' | 'disable';
  displayName: string;
  shortDisplayName?: string;
  required: boolean;
  value: number;
}

export const INTEGER_DEFAULT_CONFIG: Omit<IntegerFieldConfig, 'label' | 'displayName'> = {
  showTitle: true,
  exclusionType: 'hide',
  shortDisplayName: '',
  required: false,
  value: 0,
};

/**
 * Create default configuration for an integer field
 * @param fieldName The field name to use as label
 */
export const createIntegerConfig = (fieldName: string): IntegerFieldConfig => ({
  ...INTEGER_DEFAULT_CONFIG,
  label: fieldName,
  displayName: '',
});

export default createIntegerConfig;
